import { Component, Input } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService,
    NotificationsService, PriceService, AccountService
} from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { PopoverController, ToastController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the EventInfoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'sponsor-contact',
    templateUrl: 'sponsor-contact.html'
})
export class SponsorContactComponent extends BaseComponent {
    @Input() public sponsor: any | null;

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected accountService: AccountService,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "SponsorContactComponent"
        );

       
    }

    ngOnInit() {
        super.ngOnInit();
    }
}



// WEBPACK FOOTER //
// ./src/components/sponsor-contact/sponsor-contact.ts